module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "reactjs-icon.4280c8db.svg" + "?" + Date.now();